import React from 'react';
import ErrorPage from './ErrorPage';

const Error403 = () => <ErrorPage code={403} />;

export default Error403;
